export default "__VITE_ASSET__C8yZbrBg__"